import apiSlice from "../api/apiSlice";

export const opportunityCostsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getOpportunityCostsByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        time,
        isUpload,
        meterId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/opportunity_costs/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${isUpload !== null && isUpload !== undefined ? `&is_upload=${isUpload}` : ""}` +
          `${meterId ? `&meter_id=${meterId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "OpportunityCost", id: "LIST" }],
    }),
    /* GET by meter + time range */
    getOpportunityCostsByMeter: builder.query({
      query: ({ communityId, meterId, startDatetime, endDatetime }) => ({
        url:
          `/communities/${communityId}/opportunity_costs/by_meter?` +
          `meter_id=${meterId}&` +
          `start_datetime_timestamp=${encodeURIComponent(startDatetime)}&` +
          `end_datetime_timestamp=${encodeURIComponent(endDatetime)}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "OpportunityCost", id: "BY_METER" }],
    }),
    /* POST */
    addNewOpportunityCosts: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();
        formData.append("file_upload", file, file.name);
        return {
          url: `/communities/${communityId}/opportunity_costs/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "OpportunityCost", id: "LIST" }],
    }),
  }),
});

export const {
  useGetOpportunityCostsByCommunityIdPaginationQuery,
  useGetOpportunityCostsByMeterQuery,
  useAddNewOpportunityCostsMutation,
} = opportunityCostsApiSlice;
